module.exports = __webpack_public_path__ + "static/media/location.b2731789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.png
// module id = 905
// module chunks = 0